//node_modules
import React, { FunctionComponent } from "react";
import { CorporateContactJsonLd } from "next-seo";
import { NextSeo } from "next-seo";

//helpers
import getImageLoaderAbsoluteSrc from "@adjust/website/libs/helper/getImageLoaderAbsoluteSrc";
import getWebsiteUrl from "@adjust/website/libs/helper/getWebsiteUrl";

//hooks
import useCanonical from "@adjust/src/hooks/useCanonical";

const title = "Contact Us - Adjust to the Good Life Travel";
const description = "Contact one of our travel agents by phone, email, or fill out a form!";

const MetaComponent: FunctionComponent = () => {
  const canonical = useCanonical();
  const pageImgSrc = getImageLoaderAbsoluteSrc("/images/9b2e4478ec513ae0dd73fb5bcadf4a4e.png", 1200);
  const logoImgSrc = getWebsiteUrl("/images/82f9a2836d06afa40f3c9b1cefa86dfa.svg", false);

  return (
    <>
      <NextSeo
        title={title}
        description={description}
        canonical={canonical}
        noindex={false}
        nofollow={false}
        openGraph={{
          type: "website",
          siteName: "Adjust to the Good Life Travel",
          url: canonical,
          title: title,
          description: description,
          images: [
            {
              url: pageImgSrc,
            },
          ],
        }}
        twitter={{
          cardType: "summary_large_image",
        }}
      />
      <CorporateContactJsonLd
        keyOverride="json-contact"
        url={getWebsiteUrl("/")}
        logo={logoImgSrc}
        contactPoint={[
          {
            //Stacy Gray
            telephone: "+1-919-810-3743",
            contactType: "travel agent",
            areaServed: "US",
            availableLanguage: "English",
          },
          {
            //Haley Gray
            telephone: "+1-919-710-2657",
            contactType: "travel agent",
            areaServed: "US",
            availableLanguage: "English",
          },
          {
            //Michael Gray
            telephone: "+1-919-710-7461",
            contactType: "travel agent",
            areaServed: "US",
            availableLanguage: "English",
          },
          {
            //Jacob Gray
            telephone: "+1-919-710-0295",
            contactType: "travel agent",
            areaServed: "US",
            availableLanguage: "English",
          },
        ]}
      />
    </>
  );
};

export default React.memo(MetaComponent);
